import { observable } from 'mobx';

import ServiceClient from '../../lib/JsonServiceClient';

abstract class BaseStore<E = unknown> {
  static defaultClient = new ServiceClient('/api');

  @observable loading: boolean = false;
  @observable initialised: boolean = false;
  @observable error?: E = undefined;

  protected readonly client: ServiceClient = BaseStore.defaultClient;
}

export default BaseStore;
